import React from 'react';
import {
  Box,
  Popover,
  Text,
  InfoIcon,
  PopoverInteractiveWrapper,
} from '@razorpay/blade/components';
import { ClickableAmount } from './ClickableAmount';

interface AmountRowProps {
  label: string;
  value: number;
  tooltipContent?: string;
  onAmountClick?: () => void;
}

export const AmountRow = ({ label, value, tooltipContent, onAmountClick }: AmountRowProps) => {
  return (
    <Box display="flex" flexDirection="column" position="relative" padding="spacing.4">
      {tooltipContent ? (
        <Popover
          content={
            <Box maxWidth="200px" paddingRight="spacing.7">
              <Text size="small" color="surface.text.gray.subtle">
                {tooltipContent}
              </Text>
            </Box>
          }
          placement="bottom-start">
          <PopoverInteractiveWrapper>
            <Box
              tabIndex={0}
              display="flex"
              alignItems="center"
              gap="spacing.2"
              position="relative">
              <Text size="small" weight="regular" color="surface.text.gray.muted">
                {label}
              </Text>
              <Box>
                <InfoIcon size="small" color="surface.icon.gray.muted" />
              </Box>
            </Box>
          </PopoverInteractiveWrapper>
        </Popover>
      ) : (
        <Text size="small" weight="regular" color="surface.text.gray.muted">
          {label}
        </Text>
      )}
      <ClickableAmount value={value} onAmountClick={onAmountClick} />
    </Box>
  );
};
